import { Tabs } from "antd";
import React, { useEffect, useState } from "react";
import { ManageRolesConfigConsts } from "./constants";
import ManageRoles from "../System Settings/ManageRoles";
import { useHistory, useLocation } from "react-router-dom";
import { ExternalRolesConfig } from "../ExternalRolesConfig";

const ManageRoleConfig = () => {
  const location = useLocation();
  const history = useHistory();
  const { TabPane } = Tabs;
  const {
    INTERNAL_USERS_TAB_KEY,
    INTERNAL_USERS_LABEL,
    EXTERNAL_USERS_TAB_KEY,
    EXTERNAL_USERS_LABEL,
    TAB_TYPE,
    TAB_SIZE,
    TAB_POSITION,
  } = ManageRolesConfigConsts;

  const [activeTabKey, setActiveTabKey] = useState<string>(
    INTERNAL_USERS_TAB_KEY,
  );

  const handleTabChange = (key: string) => {
    setActiveTabKey(key);
    switch (key) {
      case INTERNAL_USERS_TAB_KEY:
        history.replace({ ...history.location, hash: INTERNAL_USERS_TAB_KEY });
        break;
      case EXTERNAL_USERS_TAB_KEY:
        history.replace({ ...history.location, hash: EXTERNAL_USERS_TAB_KEY });
        break;
    }
  };

  useEffect(() => {
    if (!!!location.hash) {
      history.replace({ ...location, hash: INTERNAL_USERS_TAB_KEY });
      setActiveTabKey(INTERNAL_USERS_TAB_KEY);
    } else {
      switch (location.hash.slice(1)) {
        case INTERNAL_USERS_TAB_KEY:
          setActiveTabKey(INTERNAL_USERS_TAB_KEY);
          break;
        case EXTERNAL_USERS_TAB_KEY:
          setActiveTabKey(EXTERNAL_USERS_TAB_KEY);
          break;
      }
    }
  }, [location.pathname, location.hash]);

  return (
    <Tabs
      swipeable
      size={TAB_SIZE}
      type={TAB_TYPE}
      tabPosition={TAB_POSITION}
      defaultActiveKey={INTERNAL_USERS_TAB_KEY}
      activeKey={activeTabKey}
      onChange={handleTabChange}
      destroyInactiveTabPane
    >
      <TabPane
        tab={INTERNAL_USERS_LABEL}
        key={INTERNAL_USERS_TAB_KEY}
        destroyInactiveTabPane
      >
        <ManageRoles />
      </TabPane>
      <TabPane
        tab={EXTERNAL_USERS_LABEL}
        key={EXTERNAL_USERS_TAB_KEY}
        destroyInactiveTabPane
      >
        <ExternalRolesConfig />
      </TabPane>
    </Tabs>
  );
};

export default ManageRoleConfig;
